export const initialConfig = {
  adminMode: false,
  showSource: false,
  fullScreen: false,
  debug: false,
  preview: false,
  fixMessage: false,
  hiddenSuggestions: false,
  theme: '',
  specialStyles: false,
  accessToken: '',
  saveSource: 'widget',
  lang: 'pl-PL',
  chatUrl: '',
  adaptiveCard: null,
  assistantId: ''
}

export const initialOptions = {
  initSuggestedQuestion: '',
  suggestedQuestion: [],
  assistantName: 'X-Talk Asystent',
  initialMessage: 'Cześć, Czego potrzebujesz?',
  assistantImage: '',
  userName: 'Ty',
  align: 'right',
  chat_id: '',
  menu: [],
  injected: {
    title: undefined
  },
  suggestedQuestionQuantity: 0
}

export const voiceOptions = {
  lang: 'pl-PL',
  rate: 1,
  pitch: 1,
  volume: 1
}

export const overrideOptions = {}
